import { isProd } from "core/model/utils/featureFlags";
import { Account } from "core/types";
import { ReactNode, createContext, useContext } from "react";

export type CareproviderAccountContext = {
  accounts?: Account[] | null | undefined;
  connected?: boolean;
  hasAccounts?: boolean;
  loggedAccount?: Account;
};

const defaultCareproviderAccountContext = {
  accounts: undefined,
  connected: false,
  hasAccounts: false,
  loggedAccount: undefined,
};

const CareproviderAccountContext = createContext<CareproviderAccountContext>(
  defaultCareproviderAccountContext,
);

export function useCareproviderAccountContext() {
  const context = useContext(CareproviderAccountContext);
  if (!isProd && (!context || context === defaultCareproviderAccountContext)) {
    console.error(
      "You are attempting to use useCareproviderAccountContext outside of a CareproviderAccountProvider",
    );
  }
  return context;
}

export function CareproviderAccountProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: CareproviderAccountContext;
}) {
  return (
    <CareproviderAccountContext.Provider value={value}>
      {children}
    </CareproviderAccountContext.Provider>
  );
}
